import { HttpContextToken } from '@angular/common/http';
import { InjectionToken } from '@angular/core';

export const CORE_APP_CONFIG = new InjectionToken<any>('CORE_APP_CONFIG');

export const BYPASS_BASE_URL = new HttpContextToken(() => false);

/** Evita il messaggio globale quando un 404 rappresenta uno stato vuoto previsto. */
export const SUPPRESS_NOT_FOUND_NOTIFICATION = new HttpContextToken(() => false);
